import { defineStore } from "pinia";
import ApiService from "@/services/ApiService";
interface IBotParams {
  has_profit: boolean;
  has_performance: boolean;
}
export const useBotStore = defineStore("botStore", {
  state: () => ({
    bot: {
      status: false,
      id: 0,
    },
    statusModal: false,
    statusLoading: false,
    bots: [],
    performanceBots: [],
    profitBots: [],
    showWalletWarning: false,
  }),
  actions: {
    triggerBotStatus(id: number, status: boolean) {
      this.bot.status = status;
      this.bot.id = id;
      this.statusModal = true;
    },
    getBots(params?: IBotParams) {
      return new Promise((resolve, reject) => {
        ApiService.query(`/bot/`, { params })
          .then((res) => {
            if (params?.has_profit) {
              this.profitBots = res?.data?.results;
            }
            if (params?.has_performance) {
              this.performanceBots = res?.data?.results;
            }
            this.bots = res?.data?.results;
            resolve(res?.data?.results);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
});
